import { Route } from '@angular/router';

export const appRoutes: Route[] = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'code',
  },
  {
    path: 'code',
    loadComponent: () => import('./pages/code/code.component').then(m => m.CodeComponent),
  },
  {
    path: 'event',
    data :{ displayForEvent: true},
    loadComponent: () => import('./pages/code/code.component').then(m => m.CodeComponent),
  },
  {
    path: 'race/screen/:eventId',
    data :{ displayForScreen: true},
    loadComponent: () => import('./pages/race/race.component').then(m => m.RaceComponent),
  },
  {
    path: 'race/:balloonCode',
    loadComponent: () => import('./pages/race/race.component').then(m => m.RaceComponent),
  },
  {
    path: 'race/:balloonCode/:secret',
    loadComponent: () => import('./pages/race/race.component').then(m => m.RaceComponent),
  },
  {
    path: 'race',
    loadComponent: () => import('./pages/race/race.component').then(m => m.RaceComponent),
  },
  {
    path: 'register/:balloonCode/:secret',
    loadComponent: () => import('./pages/register/register.component').then(m => m.RegisterComponent),
  },
];
